import { render, staticRenderFns } from "./TopicEditDialog.vue?vue&type=template&id=4da53a48&scoped=true"
import script from "./TopicEditDialog.vue?vue&type=script&lang=js"
export * from "./TopicEditDialog.vue?vue&type=script&lang=js"
import style0 from "./TopicEditDialog.vue?vue&type=style&index=0&id=4da53a48&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da53a48",
  null
  
)

export default component.exports